import React from 'react';
import ReactModal from "react-modal";

interface MenuAddMethodSelectModalProps {
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  onCreateMenuClick: () => Promise<void>;
  onSelectMenuClick: () => Promise<void>;
}

export const MenuAddMethodSelectModal = (props: MenuAddMethodSelectModalProps) => {
  const { setShowModal, onCreateMenuClick, onSelectMenuClick } = props;

  return (
    <>
      <ReactModal
        isOpen
        ariaHideApp={false}
        onRequestClose={() => setShowModal(false)}
        className="content"
        overlayClassName="overlay"
        shouldCloseOnOverlayClick
      >
        <div className="form-modal-container">
          <div className="form-modal-title">
            <h1 className="font-semibold">メニュー追加方法選択</h1>
            <button
              type="button"
              className="modal-close-btn"
              onClick={() => setShowModal(false)}
            >
              ×
            </button>
          </div>
          <div className="form-modal-content">
            <span>メニューの追加方法を選択してください。</span>
          </div>
          <div className="form-modal-footer-container">
            <button
              className="btn-sub"
              type="button"
              onClick={() => setShowModal(false)}
            >
              キャンセル
            </button>
            <button
              className="btn-primary ml-1"
              type="button"
              onClick={() => {
                onSelectMenuClick();
              }}
            >
              既存から選択
            </button>
            <button
              className="btn-primary ml-1"
              type="button"
              onClick={() => {
                onCreateMenuClick();
              }}
            >
              新規作成
            </button>
          </div>
        </div>
      </ReactModal>
    </>
  );
};
